<div class="product-list__header-top">
    <vsf-collection-breadcrumbs [breadcrumbs]="breadcrumbs$ | async"></vsf-collection-breadcrumbs>
</div>

<div class="product-list__page-title-row" *ngIf="pageTitle && !isConsolidatedFeed">
    <h1 class="product-list__page-title">{{ pageTitle }}</h1>
</div>

<div class="product-list__stats-bar" *ngIf="!isConsolidatedFeed && showStats">
    <div class="product-list__stats">
        <div *ngIf="offerCount != null">
            <b>{{ offerCount | number }}</b> offers
        </div>
        <span class="product-list__stats-dot" *ngIf="offerCount != null && brandCount != null">·</span>
        <div *ngIf="brandCount != null">
            <b>{{ brandCount | number }}</b> brands
        </div>
        <span class="product-list__stats-dot" *ngIf="(offerCount != null || brandCount != null) && sellerCount != null">·</span>
        <div *ngIf="sellerCount != null">
            <b>{{ sellerCount | number }}</b> sellers
        </div>
        <ng-container *ngIf="showFreshPrices">
            <span class="product-list__stats-dot" *ngIf="offerCount != null || brandCount != null || sellerCount != null">·</span>
            <div class="product-list__stats-fresh">
                <span class="product-list__stats-fresh-dot" aria-hidden="true"></span>
                Prices refreshed daily
            </div>
        </ng-container>
    </div>

    <div class="product-list__stats-actions">
        <vsf-export-download-menu
            label="{{ downloadLabel }}"
            buttonClass="product-list__download-btn"
            iconSrc="assets/icons/download-icon.svg"
            [showShareLink]="false"
            [skipFormatPicker]="true"
            ariaLabel="Download catalog"
            (download)="downloadAllProductsEvent.emit($event)"
            (shareLink)="shareCatalogLinkEvent.emit($event)"
        ></vsf-export-download-menu>
        <div class="relative product-list__sort-dropdown">
            <button
                type="button"
                class="product-list__download-btn"
                (click)="toggleSortDropdownEvent.emit()"
                aria-label="Sort options"
            >
                Sort: {{ activeSortLabel }}
                <img src="assets/icons/chevron-down-outline.svg" alt="" class="w-3.5 h-3.5 ml-1 opacity-50" />
            </button>
            <div *ngIf="sortDropdownOpen" class="product-list__dropdown-menu product-list__dropdown-menu--stats">
                <button
                    type="button"
                    *ngFor="let option of sortOptions"
                    (click)="selectSortOptionEvent.emit(option)"
                    class="product-list__dropdown-option"
                    [class.product-list__dropdown-option--active]="activeSortLabel === option.label"
                    [attr.aria-label]="'Sort by ' + option.label"
                >
                    {{ option.label }}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="product-list__actions--desktop" *ngIf="isConsolidatedFeed">
    <vsf-export-download-menu
        label="{{ downloadLabel }}"
        buttonClass="product-list__ghost-btn"
        iconSrc="assets/icons/download-icon.svg"
        [showShareLink]="false"
        [skipFormatPicker]="true"
        ariaLabel="Download catalog"
        (download)="downloadAllProductsEvent.emit($event)"
        (shareLink)="shareCatalogLinkEvent.emit($event)"
    ></vsf-export-download-menu>
</div>
